// @flow
import React from "react";
import { css, ThemeProvider } from "styled-components";
import { renderRoutes } from "react-router-config";
import {
  theme,
  GlobalStyles,
  Footer,
  MetaTags,
  Navigation,
} from "@nested/rebrand";
import { ProgressBar } from "./ProgressBar";
import { CovidBanner } from "./CovidBanner";

const backgroundStyle = css`
  width: 100%;
  min-height: 100vh;
  background-color: ${theme.palette.sand40};
  position: relative;
`;

const wrapperStyle = css`
  width: 100%;
  margin: 0px auto;
  max-width: 1440px;
  background-color: white;
`;

type Props = RouteProps<{}>;

export const UniversalRender = ({ route: { routes } }: Props) => (
  <ThemeProvider theme={theme}>
    <MetaTags />
    <GlobalStyles />
    <div css={backgroundStyle}>
      <div css={wrapperStyle}>
        <ProgressBar />
        <CovidBanner />
        <Navigation />
        {renderRoutes(routes)}
        <Footer />
      </div>
    </div>
  </ThemeProvider>
);
